import styled from "@emotion/styled"
import Container from "components/Container"

const HeaderNavSublist = styled(Container)`
  display: flex;
  gap: 68px;

  ${({ theme }) => theme.breakpoints.down("md")} {
    padding-bottom: 15px;
    flex-direction: column;
    gap: 24px;
  }

  ${({ theme }) => theme.breakpoints.between("md", "xl")} {
    padding-bottom: 15px;
    flex-direction: column;
    gap: 24px;
  }

  ${({ theme }) => theme.breakpoints.up("xl")} {
    max-width: 1440px;
    padding: 32px 87.5px;
  }
`

export default HeaderNavSublist
